/**
 * Puts the count in front of its label, using the singular label for exactly one and the plural label otherwise.
 * The count is placed here, not in the translation, so translators cannot change the order.
 */
export const formatCountLabel = (count: number, singular: string, plural: string): string =>
  `${count} ${count === 1 ? singular : plural}`;
